// Строки вкладки «Сетлисты» (единый сетлист, фаза 1): сетлист со звуком и
// ссылка слов — одним списком. Склейку «один сетлист = одна строка» делает
// воркер (team-setlists-merge.ts); здесь только приведение к одной форме.
import type { TeamLibrary } from '../library.js';

interface EntryBase { name: string; ownerEmail: string | null; itemCount: number; createdAt: string; eventDate: string | null }
export type LibrarySetlistEntry =
  | (EntryBase & { kind: 'audio'; setlistId: string; textShareId: string | null })
  | (EntryBase & { kind: 'words'; textShareId: string; songIds: string[] });

/** Обе разновидности рядов одним списком — сетлисты со звуком первыми, следом ссылки слов без пары. */
export function librarySetlistEntries(team: TeamLibrary): LibrarySetlistEntry[] {
  const audio: LibrarySetlistEntry[] = (team.setlists ?? []).map((s) => ({
    kind: 'audio', setlistId: s.setlistId, textShareId: s.textShareId ?? null,
    name: s.name, ownerEmail: s.ownerEmail, itemCount: s.itemCount, createdAt: s.createdAt, eventDate: s.eventDate,
  }));
  const words: LibrarySetlistEntry[] = (team.textSetlists ?? []).map((s) => ({
    kind: 'words', textShareId: s.textShareId, songIds: s.songIds,
    name: s.name, ownerEmail: s.ownerEmail, itemCount: s.itemCount, createdAt: s.createdAt, eventDate: s.eventDate,
  }));
  return [...audio, ...words];
}

/** Адрес экрана сетлиста для строки: `/setlist/<id>` со звуком, `/setlist/w/<uuid>` без. */
export function setlistEntryPath(e: LibrarySetlistEntry): string {
  return e.kind === 'audio'
    ? '/setlist/' + encodeURIComponent(e.setlistId)
    : '/setlist/w/' + encodeURIComponent(e.textShareId);
}
